(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   *  A wrapper around the ui-bootstrap $uibModal service that makes it easy
   *  to create, display, and respond to a confirmation modal.  
   **/
  factory('ConfirmModal', ['$uibModal', '$rootScope', '$sce', '$timeout', function ($uibModal, $rootScope, $sce, $timeout) {
    return {
      // Parameters:
      //  scope - a scope instance to be used for the modal's content; passed into the ui-bootstrap
      //          $uibModal service. Defaults to $rootScope.
      //  config - an object with the following properties:
      //      title:      modal title (default 'Confirm')
      //      subtitle:   modal subtitle (default null)
      //      body:       text of modal body; can use <br> or '\n' (default 'Are you sure you want to complete this action?')
      //      cancelBtn:  text on cancel button (default 'Cancel')
      //      confirmBtn: text on confirm button (default 'Ok')
      //      optionBtn:  title of option button; if null, undefined, or '' option button not shown (default)
      //      cancel:     function called if modal is closed by cancel button or ESC
      //      confirm:    function called if modal is closed by confirm button
      //      option:     function called if modal is closed by option button
      //  options - optional list of parameters passed through to ui-bootstrap modal 
      //      
      open: function open(scope, config, options) {
        if (typeof scope === 'undefined') {
          scope = $rootScope;
        }

        // only one confirm modal open at a time
        if (scope.modal) {
          return;
        }

        // default config options
        var configDefaults = {
          title: 'Confirm',
          subtitle: null,
          body: 'Are you sure you want to complete this action?',
          cancelBtn: 'Cancel',
          confirmBtn: 'Ok',
          optionBtn: null
        };

        // save config on scope for use in template
        scope.modal = angular.extend({}, configDefaults, config);
        if (!scope.modal.confirmBtnClasses) {
          scope.modal.confirmBtnClasses = 'btn-primary';
        }

        // render body (in case is uses html)
        scope.modal.body = $sce.trustAsHtml(scope.modal.body.replace(new RegExp('\r?\n', 'g'), '<br />'));
        var modalOptions = {
          templateUrl: 'modules/common/services/confirm/confirm-modal.html',
          scope: scope
        };

        // open a ui-bootstrap modal
        scope.modalInstance = $uibModal.open(angular.extend(modalOptions, options));
        scope.modalInstance.result.then(function confirmOrOption(confirm) {
          if (confirm) {
            $timeout(function () {
              // avoid invoking in current digest cycle
              (scope.modal.confirm || angular.noop)();
              scope.modal = null;
            }, 0);
          } else {
            $timeout(function () {
              (scope.modal.option || angular.noop)();
              scope.modal = null;
            }, 0);
          }
          scope.modalInstance = null;
        }, function cancel() {
          $timeout(function () {
            (scope.modal.cancel || angular.noop)();
            scope.modal = null;
          }, 0);
          scope.modalInstance = null;
        });
      }
    };
  }]);
})();
